import { CSSProperties, PropsWithChildren, forwardRef } from 'react'
import classNames from 'classnames'
import { Variants, motion } from 'motion/react'

import { Modal } from '../../../global/modal/Modal'
import { Positions } from '../../../hooks/usePopupPosition'
import { useWindowResize } from '../../../utils/domUtils'

import styles from './DropdownContent.module.scss'

const variants: Variants = {
  open: {
    opacity: 1,
    transition: {
      delay: 0.1,
      type: 'spring',
      bounce: 0,
      duration: 0.5,
    },
  },
  closed: {
    opacity: 0,
    transition: {
      type: 'spring',
      bounce: 0,
      duration: 0.25,
    },
  },
}

interface DropdownContentProps {
  isOpen: boolean
  contentOrigin: Positions | null
  style?: CSSProperties
  isPagination?: boolean
  onClose: () => void
}

export const DropdownContent = forwardRef<HTMLDivElement, PropsWithChildren<DropdownContentProps>>(
  (props, ref) => {
    const { isOpen, children, style, contentOrigin, onClose, isPagination = false } = props

    const isMobile = useWindowResize()

    if (!isOpen) {
      return null
    }

    if (isMobile) {
      return <Modal pullDown closeModal={() => onClose()} render={() => children} />
    }

    return (
      <motion.div
        onClick={(e) => e.stopPropagation()}
        animate={isOpen ? 'open' : 'closed'}
        initial='closed'
        variants={variants}
        ref={ref}
        className={classNames(styles.dropdownContent, {
          [styles.open]: isOpen,
          [styles.pagination]: isPagination,
        })}
        style={{
          top: contentOrigin?.top,
          insetInlineStart: contentOrigin?.left,
          ...style,
        }}
      >
        {children}
      </motion.div>
    )
  }
)
